import { useState } from 'react';

import Icon from 'components/global/Icon';

import { faEye, faEyeSlash } from '@fortawesome/pro-light-svg-icons';

import StringInput from './StringInput';
import * as S from './styled/PasswordInput.styled';

/**
 * @author @buunsal
 * @description password input to allow user enter password info
 * @param {Object} props - props of the component.
 * @param {Boolean} [props.disableIcon] - disable icon of the input field.
 * @param {String} [props.placeholder] - placeholder of the input field.
 * @param {Boolean} [props.disabled=false] - disabled state of the input field.
 * @param {String} [props.errorMessage] - error message of the input field.
 * @param {String} props.name - name of the input field.
 * @returns {JSX} StringInput component.
 * @example
 * <PasswordInput
 * label="Password"
 * disabled={false}
 * error={true}
 * errorMessage="Password is required"
 * name="name"
 * required={true}
 * />
 */

const PasswordInput = (props) => {
	const { disableIcon = false, ...restProps } = props;
	const [showPassword, setShowPassword] = useState(false);

	return disableIcon ? (
		<StringInput type="password" {...restProps} />
	) : (
		<S.InputContainer>
			<StringInput type={showPassword ? 'text' : 'password'} {...restProps} />
			<S.IconContainer>
				<Icon
					style={{ cursor: 'pointer' }}
					onClick={() => {
						setShowPassword(!showPassword);
					}}
					icon={showPassword ? faEyeSlash : faEye}
				/>
			</S.IconContainer>
		</S.InputContainer>
	);
};

export default PasswordInput;
